// src/hooks/useInitAuthCookie.ts
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "src/api/axiosInstance";
import {
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
  isJwtExpired,
} from "src/utils/tokenCookie";

export function useInitAuthCookie() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const at = getAccessToken();
        const rt = getRefreshToken();

        // accessToken 없으면 그냥 비로그인으로 초기화 완료
        if (!at) return;

        // accessToken이 만료면 refresh 시도
        // if (isJwtExpired(at)) {
        //   if (!rt) throw new Error("NO_REFRESH_TOKEN");
        //   console.log("refresh 1");
        //   const res = await axios.post(
        //     `${BASE_URL}/v1/admin/auth/refresh`,
        //     { refreshToken: rt },
        //     { headers: { "Content-Type": "application/json" } }
        //   );

        //   const { accessToken, refreshToken } = res.data?.data || {};
        //   if (!accessToken) throw new Error("INVALID_REFRESH_RESPONSE");

        //   setTokens(accessToken, refreshToken);
        // }
      } catch {
        // refresh 실패면 토큰 정리(여기서만 정리. 라우팅은 App에서 자연스럽게 /login)
        clearTokens();
      } finally {
        if (alive) setInitialized(true);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  return initialized;
}
